import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';
import NavSelectedIndicator from './NavSelectedIndicator';

type NavItemFrameProps = {
	selected?: boolean;
	tone?: 'default' | 'premium';
	variant?: 'default' | 'highlighted';
	children: React.ReactNode;
	className?: string;
	size?: 'default' | 'collapsed';
	groupId?: string;
	useIndicator?: boolean;
};

const NavItemFrame = ({
	selected = false,
	tone = 'default',
	size = 'default',
	variant = 'default',
	children,
	className,
	groupId = 'default',
	useIndicator = true,
}: NavItemFrameProps) => {
	const isPremium = tone === 'premium';
	const isCollapsed = size === 'collapsed';

	const surfaceClasses = twMerge(
		clsx(
			'nav-item-surface',
			variant === 'highlighted' && !selected && 'border border-tertiary bg-highlight-gradient',
			!isPremium && (selected ? 'nav-item-surface-selected' : 'nav-item-surface-idle'),
			isCollapsed && 'nav-item-collapsed',
		),
	);

	const indicator = selected && useIndicator && (
		<NavSelectedIndicator
			groupId={groupId}
			className={isPremium ? 'left-[-12px]' : undefined}
		/>
	);

	if (isPremium) {
		return (
			<div className={twMerge('relative', className)}>
				<div
					className={twMerge(
						'nav-item-premium-border',
						selected && 'nav-item-premium-border-selected',
						isCollapsed && 'p-0 nav-item-collapsed',
					)}
				>
					<div className={surfaceClasses}>
						{indicator}
						{children}
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className={twMerge('relative', surfaceClasses, className)}>
			{indicator}
			{children}
		</div>
	);
};

export default NavItemFrame;
